var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.24,462.19H189.07c-16.81-.07-31-14.41-30.95-31.23L159.6,80.45a30.45,30.45,0,0,1,30.59-30.33L330,50.77a30.44,30.44,0,0,1,30.31,30.58l-1.48,350.51A30.45,30.45,0,0,1,328.24,462.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,64.08,302.7,64a6.73,6.73,0,0,0-6.61,6.85l0,4.92a6.74,6.74,0,0,1-6.61,6.85l-52.84-.25a6.73,6.73,0,0,1-6.55-6.91l0-4.91a6.76,6.76,0,0,0-6.56-6.92l-9.53,0-23.73-.11a21.33,21.33,0,0,0-21.42,21.24L167.4,426.81a21.33,21.33,0,0,0,21.23,21.42l139.53.64a21.32,21.32,0,0,0,21.43-21.24L351,85.5A21.34,21.34,0,0,0,329.81,64.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.59,384.22c-.16,4.13-.31,8-.44,11.23h20l-2.45-12.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.13,389.37l.17,6.08h78.85c.13-3.42.28-7.2.43-11.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.75 383.07 291.21 395.44 328.17 395.44 327.72 380.61 288.75 383.07",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.59 210.08 279.58 169.57 261.28 168.21 261.28 210.08 272.59 210.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.48 366.88 167.62 374.66 167.56 388.73 188.07 387.43 187.48 366.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.39 363.72 186.31 325.99 186.29 325.99 186.29 312.68 167.87 314.63 167.63 371.44 187.38 363.7 187.39 363.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.29 282.98 168.02 280.56 167.89 311.62 186.29 309.67 186.29 282.98",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.48 313.24 321.71 324.06 300.13 326.38 301.8 334.94 326.29 333.09 325.93 320.82 327.88 312.7 322.48 313.24",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.58 336.31 300.79 335.01 297.04 315.81 282.02 317.33 283.58 336.31",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.75 338.31 285.06 354.32 287.39 376.28 288.35 381.09 327.66 378.61 326.35 335.09 283.75 338.31",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.09,262.7l1.51,2.59L187.29,283v41.95l32-2.27L281,316.43l-2.26-27.49-58.91-7.7.39-3,58.27,7.61-3.82-46.53-57.68,5.54-.19-2,57.7-5.54-2-24.28H217l-48.71,8.86-.24,55.6L186.48,280Zm-25.7,58.21s.23-34.58,0-35.87l24.74-13.16,3.21,47.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.45 313.45 298.04 315.71 299.74 324.41 319.83 322.25 320.45 313.45",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.87,376.81c-.07,1.82-.14,3.62-.2,5.4l16.68-1.06-.86-4.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.94 210.08 237.88 196.75 260.28 196.75 260.28 168.14 190.25 162.95 190.25 189.82 168.38 194.77 168.28 218.89 216.71 210.08 234.94 210.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.67,130.45l-.6-2.45,26.74-10.58L290.42,82.5a6.22,6.22,0,0,1-1,.08l-29.55-.14.8,48.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.19,111.72l0-47.67L302.7,64a6.73,6.73,0,0,0-6.61,6.85l0,4.92a7,7,0,0,1-2.86,5.64l17.4,34.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.67,113.77l-2.26-50.2-5.41,0-21.15-.1-9,44.89Zm-4.82-45.11.72,40.88-28.11-4.11,6.15-36.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.69,113.92v.42c0,3.92.12,11,.18,18.51l36.83-1.5-.8-48.91-22.29-.11a6.73,6.73,0,0,1-6.55-6.91l0-4.91a6.76,6.76,0,0,0-6.56-6.92h-3.11l2.26,50.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87,107.91l8.92-44.45a21.32,21.32,0,0,0-20.94,21.22l-.1,22.16.1-.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.25 162.73 168.52 161.34 168.39 191.69 187.25 187.42 187.25 162.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.67 108.89 168.75 107.18 168.54 156.33 171.11 156.52 180.67 108.89",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.5 363.14 218.81 323.69 187.3 325.92 188.42 364.57 218.5 363.14",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,354l44.62,21.38c.54-14,1-27,1-27.87l1-.05.48-.94c.63.31.63.31.3,9.84-.19,5.31-.45,12.38-.72,19.45h15.43l-2.27-21.44-3-37-58.31,5.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.69 288.56 333.18 283.35 279.69 288.92 281.94 316.33 328.13 311.67 333.69 288.56",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.28 199.75 240.29 199.75 238.01 210.08 260.28 210.08 260.28 199.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.43,203.24l-50.05-3.46-2,11.82,2.11,25.66,52.78-5.08Zm-48.21,8.34,2.69-7.46,43.47,2.75,2.51,21.34-47.2,5.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.62 256.87 328.42 234.18 275.61 239.25 277.6 263.4 330.62 256.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.13 389.44 167.64 390.73 167.56 389.4 167.53 395.44 188.3 395.44 188.13 389.44",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.67,100.45l.3.77L351,85.5a21.34,21.34,0,0,0-21.23-21.42l-6.65,0,0,47.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.88,376.51l-45.55-21.83-1.61-31.27-1.9.19-.33,40.5-31.05,1.47,0,.9v0h0l.6,20.88,79.59-5C268.73,380.4,268.81,378.45,268.88,376.51Zm-78.49-8.36,43.46-3,28.27,13.11-71.73,3.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,153l1.87-11.05c-16.34-5.83-17.47-22.87-17.42-28l-10.66,4.22,16.05,32.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.44 285.93 301.65 283.62 297.28 264 277.84 266.4 279.44 285.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.5 169.9 284.02 169.9 280.58 169.64 275.89 196.81 325.13 200.21 323.99 188.4 328.84 170.96 325.5 169.9",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,164.9l.52-13-16.3-32.73-25.28,10,8.69,35.68Zm-16.77-41.71,14.94,28.42-2.16,8.86-25.56-1-6.39-26.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.94 321.34 331.71 346.81 349.68 345.8 349.74 346.8 331.74 347.81 332.65 378.29 349.65 377.21 349.77 379.21 332.71 380.29 333.17 395.44 349.73 395.44 350.09 310.46 333.15 312.17 330.94 321.34",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7,114.78l-38.06-5.46-9.52,47.42,47.75,3.54C222.06,153,221.89,130.58,221.7,114.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.3 164.9 290.06 164.9 281.91 131.44 260.73 132.31 261.24 163.19 284.3 164.9",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,419.79l0,7c0,.21,0,.42,0,.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.84,160.35l37.39,2.77-.5-30.77-36.84,1.5C223,144.26,223,155.36,222.84,160.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.91 259.86 298.27 263.88 302.66 283.51 332.89 280.37 330.91 259.86",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.76,140.9l2.09-12.4,9,.7.12-26.71-27.79,11C322.61,132.28,334.42,138.89,339.76,140.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.06 188.84 330.19 200.56 350.55 201.97 350.65 177.84 333.61 172.46 329.06 188.84",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.74,288.91l-5.34,22.23,16.69-1.69.1-23.31c-5.12-1.35-9.59-2.45-12-2.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.48 165.28 350.67 172.61 350.73 159.42 327.95 153.53 327.48 165.28",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9,280.18c1.87.28,5.41,1,12.3,2.85l.22-51-17,1.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.21 231.71 350.43 230.05 350.53 204.98 330.48 203.59 333.21 231.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.68,141.53a93.52,93.52,0,0,0,9.11,2.33l0-12.66-7.33-.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.67,153.46l11.07,2.86.05-11.43c-2.87-.58-6-1.36-9.28-2.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.13,389.43l.17,6h1l-.17-6.08,79.45-5c-.15,3.9-.3,7.68-.43,11.1h2c.13-3.23.28-7.1.44-11.23l17.15-1.09,2.45,12.32h1l-2.46-12.38,39-2.46.45,14.84h5l-.46-15.16,17.06-1.08-.12-2-17,1.08-.91-30.48,18-1-.06-1-18,1-.77-25.47,2.21-9.17,16.94-1.71v-1l-16.69,1.69,5.34-22.23-.55-5.68c2.41.46,6.88,1.56,12,2.91V283c-6.89-1.82-10.43-2.57-12.3-2.85l-4.5-46.48,17-1.64v-2l-17.22,1.66-2.73-28.12,20,1.39,0-3-20.36-1.41-1.13-11.72,4.55-16.38,17,5.38,0-5.23-23.19-7.33.47-11.75,22.78,5.89v-3.1l-11.07-2.86,1.84-10.93c3.32,1,6.41,1.78,9.28,2.36v-1a93.52,93.52,0,0,1-9.11-2.33l1.83-10.9,7.33.57v-2l-9-.7-2.09,12.4c-5.34-2-17.15-8.62-16.58-27.42l27.79-11v-1.27l-.3-.77-27.48,10.88,0-47.28h-1l0,47.67-11.58,4.59-17.4-34.94a6.34,6.34,0,0,1-2.79,1.13l17.39,34.92L281.07,128l.6,2.45-21,.86-.8-48.87h-1l.8,48.91-36.83,1.5c-.06-7.54-.14-14.59-.18-18.51v-.42h0l-2.26-50.33h-1l2.26,50.2-37.83-5.43,9-44.89h-2.58l-.48,0-8.92,44.45-12-1.72-.1.65v.34l11.92,1.71-9.56,47.63-2.57-.19,0,5,18.73,1.39v24.69l-18.86,4.27v3.08l21.87-5V163l70,5.19v28.62h-22.4l-2.94,13.32H216.71l-48.43,8.81v3.05L217,213.08h55.48l2,24.28-57.7,5.54.19,2,57.68-5.54,3.82,46.53-58.27-7.61-.39,3,58.91,7.7L281,316.43l-61.67,6.22-32,2.27V283l30.31-17.68-1.51-2.59L186.48,280,168,277.54v3L186.29,283v26.69l-18.4,1.95,0,3,18.42-1.95V326h0l1.09,37.73v0l-19.75,7.74v3.22l19.86-7.78.59,20.55-20.51,1.3v.67l.08,1.33Zm82.54-7.22c.06-1.78.13-3.58.2-5.4l15.62,0,.86,4.3Zm17.68-1.12-1-4.81-2.33-22-1.31-16,42.6-3.22,1.31,43.51ZM298,315.71l22.42-2.26-.63,8.8-20.09,2.16Zm-1,.1,3.75,19.2-17.21,1.3-1.56-19Zm29.25,17.28-24.49,1.85-1.67-8.56,21.58-2.32.77-10.82,5.4-.54-1.95,8.12Zm-29-69.09,4.37,19.62-22.21,2.31-1.6-19.53Zm5.38,19.51-4.39-19.63,32.64-4,2,20.51Zm22.47-83.3-49.24-3.41,4.69-27.16,3.44.26h41.49l3.33,1.06L324,188.4Zm-3-86.33c-.05,5.16,1.08,22.2,17.42,28L337.72,153l-10.16-2.63L311.51,118.1Zm-13.46,5.33L325,151.94l-.52,13H292.12l-8.69-35.68Zm-26.8,12.23,8.15,33.46H284.3l-23.06-1.7-.51-30.89Zm-22.18.91.5,30.77-37.39-2.77c.16-5,.13-16.09,0-26.5Zm-76.09-23,38.06,5.46c.19,15.8.36,38.2.17,45.5l-47.75-3.54Zm95.94,60.25-7,40.51H261.28V168.21Zm-39.29,30.19h20v10.32H238Zm33,11.84,2-11.82,50.05,3.46,2.8,28.94-52.78,5.08Zm55.08,22.58,2.2,22.69-53,6.54-2-24.16Zm-48.73,54.74,53.49-5.57.51,5.21-5.56,23.11-46.19,4.66Zm4.38,65.49,2.27,21.44H270.91c.27-7.07.53-14.14.72-19.45.33-9.53.33-9.53-.3-9.84l-.48.94-1,.05c0,.83-.43,13.9-1,27.87L224.3,354l-1.58-30.73L281,317.43Zm-65.26-30.72-.31,39.45-30.08,1.43-1.12-38.65Zm-30.34,42.8h0v0l0-.9,31.05-1.47.33-40.5,1.9-.19,1.61,31.27,45.55,21.83c-.07,1.94-.15,3.89-.22,5.83l-79.59,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.85 365.1 190.39 368.14 190.39 382.1 262.13 378.21 233.85 365.1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.38 206.87 279.91 204.12 277.22 211.58 278.69 233.81 325.89 228.21 323.38 206.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.63,448.23l139.53.64a21.32,21.32,0,0,0,21.43-21.24l.14-32.18H167.53l-.1,24.34v7.66A21.32,21.32,0,0,0,188.63,448.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.57 109.54 216.85 68.66 195.62 68.66 189.46 105.43 217.57 109.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.5 160.47 322.66 151.61 307.72 123.19 288.55 132.63 294.94 159.51 320.5 160.47",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.39,285c.23,1.29,0,35.87,0,35.87l28-1.76-3.21-47.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.59 313.12 282.11 291.69 330.04 285.53 330.04 289.23 324.24 308.94 283.59 313.12",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14,135.39a5.84,5.84,0,1,1-5.84-5.84A5.84,5.84,0,0,1,248.14,135.39Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.13,135.14a5.84,5.84,0,1,1-6.08-5.58A5.84,5.84,0,0,1,248.13,135.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 242.3,
    cy: 135.19,
    r: 3.88,
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.53,368.54A2.5,2.5,0,1,1,330,366,2.5,2.5,0,0,1,332.53,368.54Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.54,367.73l-.61-14-42.12,2.05a6.43,6.43,0,0,1-3.19-.68l-59.75-30.18a4.34,4.34,0,0,1-2.37-3.64l-8.14-157.74a2.63,2.63,0,0,1,2.83-2.76l25.61,1.89v-28h3v28.38A2.65,2.65,0,0,1,243,165a2.69,2.69,0,0,1-2,.69l-25.59-1.89,8.11,157.33a1.34,1.34,0,0,0,.73,1.11L284,352.44a3.39,3.39,0,0,0,1.69.36l42.48-2.07a2.67,2.67,0,0,1,1.91.69,2.63,2.63,0,0,1,.87,1.85l.61,14.33Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.26,
    cy: 232.05,
    r: 7.56,
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.26,
    cy: 232.05,
    r: 5.25,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,237.68a5.63,5.63,0,1,1,5.62-5.63A5.64,5.64,0,0,1,217.26,237.68Zm0-10.51a4.88,4.88,0,1,0,4.87,4.88A4.89,4.89,0,0,0,217.26,227.17Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,200.34h-36a3.17,3.17,0,0,0-3.17,3.17v13a3.17,3.17,0,0,0,3.17,3.17h.42v3.11l3.61-3.11h32a3.17,3.17,0,0,0,3.17-3.17v-13A3.17,3.17,0,0,0,261.79,200.34Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.79,200.34h-36a3.17,3.17,0,0,0-3.17,3.17v13a3.17,3.17,0,0,0,3.17,3.17h.42v3.11l3.61-3.11h32a3.17,3.17,0,0,0,3.17-3.17v-13A3.17,3.17,0,0,0,261.79,200.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.72,209.82a2.16,2.16,0,1,1,2.17,2.08A2.07,2.07,0,0,1,230.72,209.82Zm3.74,0a1.58,1.58,0,1,0-1.57,1.57A1.52,1.52,0,0,0,234.46,209.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,210.32a1.49,1.49,0,0,1-1.55,1.57,1.29,1.29,0,0,1-1.1-.52v.49h-.54v-4.32h.56v1.7a1.32,1.32,0,0,1,1.08-.49A1.49,1.49,0,0,1,239,210.32Zm-.56,0a1,1,0,1,0-1,1.08A1,1,0,0,0,238.48,210.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75,212.83l.18-.43a.69.69,0,0,0,.46.15c.29,0,.46-.19.46-.54v-3.23h.55V212a.92.92,0,0,1-1,1A1.11,1.11,0,0,1,238.75,212.83Zm1-5a.36.36,0,0,1,.37-.36.36.36,0,0,1,.38.35.36.36,0,0,1-.38.37A.35.35,0,0,1,239.75,207.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.24,210.5h-2.5a1,1,0,0,0,1.12.9,1.16,1.16,0,0,0,.89-.37l.31.36a1.69,1.69,0,0,1-2.88-1.07,1.51,1.51,0,0,1,1.55-1.57,1.48,1.48,0,0,1,1.52,1.58A1,1,0,0,1,244.24,210.5Zm-2.5-.4h2a1,1,0,0,0-2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,210.32a1.54,1.54,0,0,1,1.63-1.57,1.36,1.36,0,0,1,1.25.65l-.42.28a1,1,0,0,0-.84-.45,1.09,1.09,0,0,0,0,2.17,1,1,0,0,0,.84-.44l.42.27a1.37,1.37,0,0,1-1.25.66A1.55,1.55,0,0,1,244.74,210.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12,211.68a1.1,1.1,0,0,1-.68.21.87.87,0,0,1-1-1v-1.7h-.53v-.45h.53v-.68H249v.68h.88v.45H249v1.67a.45.45,0,0,0,.48.52.69.69,0,0,0,.43-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69,207.82a.37.37,0,0,1,.38-.36.36.36,0,0,1,.38.35.38.38,0,0,1-.76,0Zm.1,1h.56v3.08h-.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,208.78l-1.35,3.08h-.57l-1.35-3.08h.59l1,2.47,1.08-2.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.35,210.5h-2.5a1,1,0,0,0,1.12.9,1.16,1.16,0,0,0,.89-.37l.3.36a1.51,1.51,0,0,1-1.21.5,1.55,1.55,0,0,1-1.66-1.57,1.51,1.51,0,0,1,1.55-1.57,1.48,1.48,0,0,1,1.52,1.58A1,1,0,0,1,258.35,210.5Zm-2.5-.4h2a1,1,0,0,0-2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,115.78A7.48,7.48,0,1,0,236,119.56h0l0,0c.29.48.65.83,1,1.34l4.35,5.75a1.35,1.35,0,0,0,2.16,0l4.27-5.66a15.94,15.94,0,0,0,1.09-1.44v0h0A7.46,7.46,0,0,0,249.9,115.78ZM242.42,119a3.3,3.3,0,1,1,3.29-3.3A3.3,3.3,0,0,1,242.42,119Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.44,410.65h-1.39v-.51h3.36v.51H202v3.56h-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.36,412.67a1.6,1.6,0,1,1,1.61,1.58A1.53,1.53,0,0,1,203.36,412.67Zm2.64,0a1,1,0,1,0-2.07,0,1,1,0,1,0,2.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.07,414a1,1,0,0,1-.67.22.88.88,0,0,1-1-1v-1.69h-.52v-.46h.52v-.67H208v.67h.88v.46H208v1.67a.45.45,0,0,0,.48.52.75.75,0,0,0,.44-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,412.35v1.86h-.53v-.4a1.17,1.17,0,0,1-1,.44c-.7,0-1.14-.37-1.14-.91s.32-.9,1.23-.9h.89v-.11c0-.47-.27-.75-.83-.75a1.5,1.5,0,0,0-1,.34l-.24-.42a2,2,0,0,1,1.28-.4A1.15,1.15,0,0,1,212.19,412.35Zm-.56.92v-.43h-.86c-.55,0-.71.22-.71.48s.25.5.68.5A.89.89,0,0,0,211.63,413.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.22,409.9h.56v4.31h-.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.31,409.9v4.31h-.53v-.49a1.31,1.31,0,0,1-1.1.53,1.58,1.58,0,0,1,0-3.15,1.3,1.3,0,0,1,1.08.5v-1.7Zm-.55,2.77a1,1,0,1,0-1,1.09A1,1,0,0,0,218.76,412.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.27,410.18a.37.37,0,0,1,.38-.37.37.37,0,1,1,0,.73A.37.37,0,0,1,220.27,410.18Zm.1.95h.56v3.08h-.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6,413.89l.24-.45a1.94,1.94,0,0,0,1.08.32c.52,0,.73-.15.73-.41,0-.7-2-.1-2-1.32,0-.56.5-.93,1.29-.93a2.29,2.29,0,0,1,1.12.28l-.24.44a1.62,1.62,0,0,0-.89-.24c-.49,0-.72.18-.72.42,0,.73,2,.14,2,1.33,0,.56-.51.92-1.33.92A2.29,2.29,0,0,1,221.6,413.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.64,414a1,1,0,0,1-.68.22.88.88,0,0,1-1-1v-1.69h-.53v-.46H225v-.67h.56v.67h.88v.46h-.88v1.67a.45.45,0,0,0,.48.52.7.7,0,0,0,.43-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.76,412.35v1.86h-.53v-.4a1.18,1.18,0,0,1-1,.44c-.69,0-1.14-.37-1.14-.91s.32-.9,1.24-.9h.89v-.11c0-.47-.28-.75-.83-.75a1.55,1.55,0,0,0-1,.34l-.23-.42a2,2,0,0,1,1.28-.4A1.15,1.15,0,0,1,229.76,412.35Zm-.56.92v-.43h-.86c-.56,0-.71.22-.71.48s.25.5.68.5A.89.89,0,0,0,229.2,413.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.71,412.44v1.77h-.55V412.5c0-.6-.31-.9-.84-.9a.92.92,0,0,0-1,1v1.58h-.56v-3.08h.53v.47a1.33,1.33,0,0,1,1.12-.5A1.19,1.19,0,0,1,233.71,412.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,412.67a1.54,1.54,0,0,1,1.63-1.57,1.39,1.39,0,0,1,1.26.66l-.43.27a1,1,0,0,0-.84-.44,1.09,1.09,0,0,0,0,2.17,1,1,0,0,0,.84-.44l.43.26a1.4,1.4,0,0,1-1.26.67A1.55,1.55,0,0,1,234.48,412.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.81,412.86h-2.5a1,1,0,0,0,1.12.9,1.16,1.16,0,0,0,.89-.37l.31.36a1.58,1.58,0,0,1-1.22.5,1.55,1.55,0,0,1-1.66-1.58,1.51,1.51,0,0,1,1.55-1.57,1.48,1.48,0,0,1,1.52,1.59A1,1,0,0,1,240.81,412.86Zm-2.5-.4h2a1,1,0,0,0-2,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1,418.78v9.7h-2.25v-7.9h-1.94v-1.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.41,427.24a3.31,3.31,0,0,1-.37,1.38l-.8,2h-1.37l.61-2.2a1.21,1.21,0,0,1-.75-1.18,1.34,1.34,0,1,1,2.68,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,418.78v9.7H211.7v-7.9h-1.94v-1.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.64,423.63c0-3.2,1.77-5,4.16-5s4.16,1.82,4.16,5-1.76,5-4.16,5S215.64,426.83,215.64,423.63Zm6.06,0c0-2.2-.78-3.12-1.9-3.12s-1.89.92-1.89,3.12.78,3.12,1.89,3.12S221.7,425.84,221.7,423.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.05,423.63c0-3.2,1.78-5,4.17-5s4.16,1.82,4.16,5-1.76,5-4.16,5S225.05,426.83,225.05,423.63Zm6.07,0c0-2.2-.78-3.12-1.9-3.12s-1.89.92-1.89,3.12.78,3.12,1.89,3.12S231.12,425.84,231.12,423.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.46,424.21v4.27H249.3v-3.93c0-1.21-.54-1.77-1.42-1.77s-1.65.63-1.65,2v3.74h-2.16v-3.93c0-1.21-.51-1.77-1.41-1.77s-1.64.63-1.64,2v3.74h-2.16V421h2.06v.86a3,3,0,0,1,2.35-1,2.78,2.78,0,0,1,2.45,1.22,3.37,3.37,0,0,1,2.69-1.22C250.19,420.91,251.46,421.94,251.46,424.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.8,
    cy: 418.02,
    r: 8.37,
    transform: "translate(-262.88 504.17) rotate(-76.77)",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,419.54a13.07,13.07,0,0,1,2.15-.13c1.37,0,3.33-.07,5.67-.09l-.17.37c-.67-.76-1.38-1.6-2.14-2.47l-.13-.15.13-.17,2.11-2.63.2.42h-1l-6.87,0,.24-.23c0,2.54-.06,4.68-.1,6.18a14.85,14.85,0,0,1-.14,2.37,16.51,16.51,0,0,1-.14-2.37c0-1.5-.07-3.64-.09-6.18v-.23h.23l6.87,0h1.49l-.34.42-2.13,2.63v-.32l2.1,2.5.32.37h-.49c-2.34,0-4.3-.06-5.67-.09A12.25,12.25,0,0,1,183.42,419.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.22,403.73h-25.3a4.85,4.85,0,0,0-4.85,4.85V428.5a4.85,4.85,0,0,0,4.85,4.84h.64v4.75l5.51-4.75h19.15a4.85,4.85,0,0,0,4.85-4.84V408.58A4.85,4.85,0,0,0,322.22,403.73Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.33,412.87v10.22a.4.4,0,0,0,.4.4h21.42a.4.4,0,0,0,.39-.41l-.05-3.74a.39.39,0,0,0-.07-.23L318.34,415a.38.38,0,0,0-.31-.16l-3.54,0a.4.4,0,0,1-.4-.39v-1.55a.39.39,0,0,0-.39-.4h-14A.4.4,0,0,0,299.33,412.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,415.71V419a.23.23,0,0,0,.23.23l4.73-.08a.23.23,0,0,0,.18-.36L318,415.51a.21.21,0,0,0-.19-.1l-2.52.07A.22.22,0,0,0,315.09,415.71Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.9,
    y: 423.8,
    width: 23.07,
    height: 0.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.53,424.07a2.29,2.29,0,1,1-2.28-2.28A2.28,2.28,0,0,1,306.53,424.07Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.59,424.07a1.35,1.35,0,1,1-1.34-1.34A1.34,1.34,0,0,1,305.59,424.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.08,423.49c-.06,0-.11-2.47-.11-5.51s0-5.51.11-5.51.1,2.47.1,5.51S314.13,423.49,314.08,423.49Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,424.07a2.28,2.28,0,1,1-2.28-2.28A2.28,2.28,0,0,1,319,424.07Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,424.07a1.35,1.35,0,1,1-1.35-1.34A1.35,1.35,0,0,1,318,424.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.69,419.86c0,.06-.33.1-.73.1s-.73,0-.73-.1.33-.11.73-.11S316.69,419.8,316.69,419.86Z",
    style: {
      fill: "#015441"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.34,252.13s16.13,2.72,17.43,3.07,6.41,2.77,6.67,4.33a46.79,46.79,0,0,1,0,6.15s-.93.75-1.5-.75a15.31,15.31,0,0,1-.49-4.47l-2.86-1.1,1.56,2.77.26,6.49s-2-.18-2.39-1.73a15.31,15.31,0,0,1-.38-3.29l-2.08-1.76,1.56,2.11.52,4.67s-1.52.5-2-.54a16.1,16.1,0,0,1-.52-4.13l-5.88-2.06-3.89,2.17L554.08,260Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.86,212.26c.08.32,19.44,27,19.44,27l38.9,12.1-1.77,14.61-47.67-9.6-16.92-19.42Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.86,212.26c.08.32,19.44,27,19.44,27l38.9,12.1-1.77,14.61-47.67-9.6-16.92-19.42Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 348.57,
    y: 248.95,
    width: 85.58,
    height: 15.49,
    rx: 3.05,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.11,264.44s.17,0,.5-.07a3,3,0,0,0,2.44-2.63c0-.94,0-2.06,0-3.3s0-2.63,0-4.14c0-.76,0-1.55,0-2.37a3,3,0,0,0-1-2.14,2.91,2.91,0,0,0-1.13-.59,4.59,4.59,0,0,0-1.35-.09h-2.92l-6.35,0-69.61.08a2.8,2.8,0,0,0-2.07.91,2.87,2.87,0,0,0-.72,2.15c0,1.68,0,3.35,0,5V261a4.18,4.18,0,0,0,.1,1.14,2.82,2.82,0,0,0,2.39,2.05c.35,0,.78,0,1.18,0l18.48,0,31.29.06,21.1.08,5.74.05,1.49,0,.51,0-.51,0-1.49,0-5.74.05-21.1.08-31.29.06H352.5c-.41,0-.79,0-1.24,0a3.41,3.41,0,0,1-1.24-.4,3.31,3.31,0,0,1-1.58-2,4.06,4.06,0,0,1-.12-1.28v-3.71c0-1.65,0-3.32,0-5a3.45,3.45,0,0,1,.87-2.5,3.28,3.28,0,0,1,2.45-1.08l69.61.08h9.27a5.76,5.76,0,0,1,1.43.12,3.16,3.16,0,0,1,1.24.66,3.22,3.22,0,0,1,1.11,2.35c0,.82,0,1.62,0,2.38,0,1.51,0,2.89,0,4.14s0,2.34-.05,3.32a3.16,3.16,0,0,1-1.21,2.09,3,3,0,0,1-1.38.57A1.78,1.78,0,0,1,431.11,264.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 644.95,
    cy: 421.54,
    r: 40.89,
    transform: "translate(-19.48 31.42) rotate(-2.75)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.08,420.84s0,.07,0,.11a40.89,40.89,0,0,0,81.77,1.18s0-.07,0-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.25,421.12a28.71,28.71,0,1,0,29.12-28.29A28.71,28.71,0,0,0,616.25,421.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.37,392.83a28.71,28.71,0,0,0-29.12,28.29l57.41.83A28.71,28.71,0,0,0,645.37,392.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.47,421.28a17.49,17.49,0,1,0,17.74-17.23A17.49,17.49,0,0,0,627.47,421.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.55,361.58s41.86-12.66,59.17,32.82l-87.6,27.14Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.67,
    cy: 421.54,
    r: 40.89,
    transform: "translate(-19.77 19.32) rotate(-2.75)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.79,420.84s0,.07,0,.11a40.89,40.89,0,0,0,81.77,1.18V422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,421.12a28.71,28.71,0,1,0,29.12-28.29A28.71,28.71,0,0,0,364,421.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.08,392.83A28.71,28.71,0,0,0,364,421.12l57.41.83A28.71,28.71,0,0,0,393.08,392.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,421.28a17.49,17.49,0,1,0,17.74-17.23A17.49,17.49,0,0,0,375.18,421.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.83,405.12c-.23.12-21.52-3.29-21.52-3.29h0a13,13,0,0,1-9.71,5.08c-9.2.44-18.19.85-26,1.2A13.2,13.2,0,0,0,381,421.84h0a13.21,13.21,0,0,0,12.67,12.64L439,436.27c7.45.29,17.35-4.23,22-10.06h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.58,387s-1.94-39.85,35.51-48.15v-5.11H506.27V346s-19.25,23.19-13,42.44,8.25,21.22,8.25,21.22h74.66a51,51,0,0,0,9.43-28.29c.4-16.9-6.62-45.79-11.87-64.26C569,300.26,566,286.22,566,286.22l22.4-7.47S629.85,333,631.54,336s7.45,10.16,6.1,25.74S599,425.38,589.22,430.8s-18.62,5.76-27.43,7.11c-7.64,1.18-64.16.4-78.95.17a29,29,0,0,1-14.6-4.05c-4.42-2.68-7.74-7.12-11.41-14.4L449,404.39Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.62,384.26,333.1,410.14a4,4,0,0,0,4.91,5.92,19.24,19.24,0,0,0,5.55-3.76c7.55-7.19,21-26.13,21-26.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.11,388.92s0-.13.1-.38l.33-1.09a28.76,28.76,0,0,0,.87-4.27,30.14,30.14,0,0,0-2.56-15.62,32.72,32.72,0,0,0-6.09-9.15,39.94,39.94,0,0,0-10-7.66,50.62,50.62,0,0,0-13.1-4.88,69,69,0,0,0-15-1.55,113,113,0,0,0-15,1.11c-4.84.65-9.48,1.45-13.86,2.45a82.08,82.08,0,0,0-22.25,8.23,55.06,55.06,0,0,0-12.71,9.71c-1.32,1.36-2.27,2.49-2.9,3.26l-.71.89a1.79,1.79,0,0,1-.26.29,33.61,33.61,0,0,1,3.72-4.58,54,54,0,0,1,12.68-9.89,81.36,81.36,0,0,1,22.33-8.38c4.38-1,9-1.83,13.89-2.49a113.77,113.77,0,0,1,15.12-1.12,68.81,68.81,0,0,1,15.08,1.57,51.23,51.23,0,0,1,13.22,5,40.21,40.21,0,0,1,10.13,7.78,32.92,32.92,0,0,1,6.11,9.3,30,30,0,0,1,2.42,15.8,25.52,25.52,0,0,1-1,4.27c-.16.46-.28.81-.38,1.08A2.11,2.11,0,0,1,468.11,388.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.56,380c-.06,0,.21-.63.49-1.77a12.94,12.94,0,0,0,.15-5,20.55,20.55,0,0,0-2.44-6.94,23.7,23.7,0,0,0-2.42-3.64,21.94,21.94,0,0,0-3.25-3.37,28.39,28.39,0,0,0-7.8-4.56,36.71,36.71,0,0,0-7.16-2,46.88,46.88,0,0,0-5-.57,14.69,14.69,0,0,1-1.84-.14,1.61,1.61,0,0,1,.48,0c.31,0,.77,0,1.37,0a37.4,37.4,0,0,1,5,.41,34.58,34.58,0,0,1,7.28,1.87,28.51,28.51,0,0,1,8,4.61,22.91,22.91,0,0,1,3.32,3.45,25,25,0,0,1,2.43,3.73,19.9,19.9,0,0,1,2.38,7.12,12.32,12.32,0,0,1-.31,5.06,7.19,7.19,0,0,1-.48,1.29A1.76,1.76,0,0,1,460.56,380Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.87,345.06a52.54,52.54,0,0,1,19.75,8,34.91,34.91,0,0,1,13.23,16.44c2.62,6.74,2.23,15.67-.53,21.25l9.27.77c3.12-10.41-.27-23.18-7.77-31.33a46,46,0,0,0-33.95-15.17"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 342.24,
    y: 263.66,
    width: 98.25,
    height: 70.11,
    rx: 8.58,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.49,279.3c0,.15-22.09.26-49.33.26s-49.34-.11-49.34-.26,22.08-.26,49.34-.26S440.49,279.16,440.49,279.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.21,338.41c0,.14-29.49.26-65.85.26s-65.85-.12-65.85-.26,29.48-.26,65.85-.26S506.21,338.27,506.21,338.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.27,333.77a11.34,11.34,0,0,0,2.38-5.88c.2-3.29-1.3-7.41-4.85-7.41H458.5a13.29,13.29,0,0,0-13.29,13.29h61.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566,286.22l-7.88-16.43a10,10,0,0,1,4-12.85l23.56-14.05a7.9,7.9,0,0,1,4.07-1.13h5.09l2,33.21L589,278l5,8.08Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.91,243s8.06,1.85,9.07,14.27-7.11,16.3-7.11,16.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.75,263.35s-16.29,7.72-18.28,9c-1.38.88-2.56,2.42-1.48,5.13,1.84,4.61,9.46.27,9.46.27l15.17-7.58s5.83-2.75,3.67-6.2C574.88,260.11,568.75,263.35,568.75,263.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.69,260.54s15.31,2.62,16.61,3,6.4,2.77,6.66,4.33a46.79,46.79,0,0,1,0,6.15s-.92.75-1.5-.75a15.77,15.77,0,0,1-.49-4.48l-2.86-1.1,1.56,2.77.26,6.5s-2-.18-2.38-1.74a15.18,15.18,0,0,1-.38-3.28l-2.09-1.77,1.56,2.11.53,4.68s-1.52.49-2-.55a16.06,16.06,0,0,1-.52-4.13l-5.88-2.05-3.89,2.17L544.76,269Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.53,239.22c0,6.2-2.85,11.22-6.36,11.22s-6.36-5-6.36-11.22S559.65,228,563.17,228,569.53,233,569.53,239.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.21,246.93l3.5,12.12a3.14,3.14,0,0,0,1.63-3.58c-.88-4.15-1.38-7.1-2.34-10.74-.12-.36-2.79,2.2-2.79,2.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495,393.57c-.34-1-.7-2-1-3.07s-.68-2-.94-3a32.21,32.21,0,0,1-.88-4.57c-5.9,24,3.11,40.93,18.57,42.12,22.6,1.74,50.15,3,61.29.08,20.31-5.33,27.76-22.27,29.54-25.06s17.93-32.32,8-60.75-27.15-58.62-27.15-58.62L566,286.22s3,14,7.77,30.84c5.25,18.47,12.27,47.36,11.87,64.26a51,51,0,0,1-9.43,28.29H501.56s-1.6-1.6-6.53-16"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.6,380.78l.53-5.7,136.28,15.7a13.46,13.46,0,0,1,11.68,15.72l-.61,3.45-141-20.49A8,8,0,0,1,336.6,380.78Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.6,380.78l.53-5.7,136.28,15.7a13.46,13.46,0,0,1,11.68,15.72l-.61,3.45-141-20.49A8,8,0,0,1,336.6,380.78Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M601.58,418.9s30-33,36.19-58.94a58.33,58.33,0,0,1,9.29.69S629.32,408.88,601.58,418.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M637.33,348.34a4.81,4.81,0,0,1,.16.83c.08.55.24,1.36.34,2.41a36.74,36.74,0,0,1-.23,9,45.46,45.46,0,0,1-4,12.68,143.7,143.7,0,0,1-7.94,14.2,189.6,189.6,0,0,1-17.56,23.74c-2.44,2.89-4.46,5.19-5.86,6.77l-1.62,1.81a7,7,0,0,1-.59.61,4.46,4.46,0,0,1,.51-.67l1.55-1.88,5.73-6.87a206.16,206.16,0,0,0,17.4-23.78,152.39,152.39,0,0,0,8-14.13,46.41,46.41,0,0,0,4-12.54,40,40,0,0,0,.39-8.88c-.07-1.05-.2-1.86-.24-2.42A4.42,4.42,0,0,1,637.33,348.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.47,418.66a40.08,40.08,0,0,1-4.81-4.34,41.15,41.15,0,0,1-4.44-4.71,80.15,80.15,0,0,1,9.25,9.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.43,417.65a13.89,13.89,0,0,1,2.21-4.27,14.07,14.07,0,0,1,3.15-3.63c.11.11-1.26,1.75-2.72,3.92S496.57,417.71,496.43,417.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.79,436.7a20.14,20.14,0,0,0,4.09-5.2,17.9,17.9,0,0,0,2-6.85,15.91,15.91,0,0,0-7.18-15,17.87,17.87,0,0,0-6.58-2.75,20.11,20.11,0,0,0-6.61-.09,1.93,1.93,0,0,1,.44-.13,10.9,10.9,0,0,1,1.32-.26,15.69,15.69,0,0,1,4.92.12,17.89,17.89,0,0,1,6.78,2.71,16.16,16.16,0,0,1,7.39,15.49,17.89,17.89,0,0,1-2.16,7,15.5,15.5,0,0,1-3,3.9,10.27,10.27,0,0,1-1,.87A1.87,1.87,0,0,1,438.79,436.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,426.25a21.48,21.48,0,0,1-.49-4.8,22.71,22.71,0,0,1,0-4.84,44.88,44.88,0,0,1,.46,9.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,426.26a46.3,46.3,0,0,1-1.23-9.66,23.52,23.52,0,0,1,.87,4.8A23.28,23.28,0,0,1,392.64,426.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.85,333.77c0,.14-16.57.26-37,.26s-37-.12-37-.26,16.57-.26,37-.26S448.85,333.62,448.85,333.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.19,333.72c-.15,0-.26-19-.26-42.38S395,249,395.19,249s.26,19,.26,42.39S395.33,333.72,395.19,333.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,333.65c-.14,0,.57-19,1.59-42.36s2-42.35,2.1-42.34-.56,19-1.58,42.36S385.19,333.66,385,333.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.09,449.3a3.25,3.25,0,0,1-.44-.45c-.26-.3-.69-.73-1.16-1.34a38.38,38.38,0,0,1-3.69-5.42,41.43,41.43,0,0,1,.17-41.48,37.66,37.66,0,0,1,3.73-5.39c.48-.61.91-1,1.18-1.34s.43-.45.44-.43a2.52,2.52,0,0,1-.36.5c-.24.33-.65.77-1.1,1.4a42.27,42.27,0,0,0-3.74,46.56,42.57,42.57,0,0,0,3.53,5.47c.44.63.84,1.08,1.08,1.41S362.11,449.28,362.09,449.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.35,373.11l-.31.58L499,385l-8.44,8.12,16.87,22.46,14.05-2.33s-1.57-3.21-8.63-3.83L510.18,396l9.91-15.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.58 393.15 507.45 415.61 521.5 413.28 519.57 411.43 508.04 412.69 492.38 391.42 490.58 393.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.75,403.28c-.08.16-1-.17-2,.05s-1.81.79-1.94.67.5-1.06,1.82-1.29S511.86,403.15,511.75,403.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,400c-.12.12-.89-.6-2-.64s-2,.63-2.09.5.07-.31.43-.6a2.71,2.71,0,0,1,1.68-.52,2.63,2.63,0,0,1,1.64.63C510.93,399.65,511,399.92,511,400Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.35,395.65c-.14.11-.76-.62-1.79-.8s-1.86.29-2,.14.09-.29.46-.5a2.47,2.47,0,0,1,3,.54C510.36,395.35,510.42,395.61,510.35,395.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.55,391.7c-.15.08-.68-.65-1.65-1.07s-1.85-.36-1.89-.53,1-.58,2.15,0S513.72,391.65,513.55,391.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.91,388.51c-.07.05-.62-.43-1.47-1.27L512,385.75a4.6,4.6,0,0,1-.84-1,1.13,1.13,0,0,1-.06-.87.87.87,0,0,1,.77-.58,2.56,2.56,0,0,1,1.43.46,5.27,5.27,0,0,1,1,.83,4.87,4.87,0,0,1,1.07,1.91,2.63,2.63,0,0,1,0,2,15,15,0,0,0-.42-1.83,5,5,0,0,0-1.07-1.65,4.58,4.58,0,0,0-.91-.7,2.33,2.33,0,0,0-1.06-.37.26.26,0,0,0-.24.17.54.54,0,0,0,0,.41,4.42,4.42,0,0,0,.7.88l1.37,1.59A6,6,0,0,1,514.91,388.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.48,388.84c-.07,0-.14-.74.48-1.71a3.56,3.56,0,0,1,4-1.45.68.68,0,0,1,.3.47.84.84,0,0,1-.1.47,2,2,0,0,1-.43.53,6.69,6.69,0,0,1-.9.73,6.23,6.23,0,0,1-1.76.82,2.88,2.88,0,0,1-1.76.13c0-.1.65-.16,1.62-.55a7,7,0,0,0,1.57-.87,6.36,6.36,0,0,0,.8-.7,1.59,1.59,0,0,0,.31-.37c.05-.14,0-.1,0-.13a1.11,1.11,0,0,0-.43-.09,3.11,3.11,0,0,0-.53,0,3.5,3.5,0,0,0-1,.24,3.43,3.43,0,0,0-1.39,1A12.41,12.41,0,0,0,515.48,388.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.72,390.86a1.69,1.69,0,1,1-1.94-1.39A1.7,1.7,0,0,1,501.72,390.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.55,383.91l4.51,29.28,36.47-5.42c-.74-3.45-20.64-7.64-20.64-7.64l-2.12-18.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.38,400.23a1.5,1.5,0,0,0-.78,1.85,1.46,1.46,0,0,0,1.83.79,1.59,1.59,0,0,0,.81-2,1.5,1.5,0,0,0-2-.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.06,413.19l-.34-3,35.09-4.09s1.73.47,1.72,1.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.45,399.86c0,.18-.85.39-1.65,1.09s-1.14,1.52-1.32,1.48-.06-1.12.91-1.95S577.47,399.69,577.45,399.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.51,400.87c.07.17-.66.58-1.15,1.43s-.55,1.66-.73,1.68-.44-1,.19-2S581.48,400.7,581.51,400.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.37,405.12c-.16.07-.54-.79-.23-1.83s1.09-1.56,1.19-1.42-.34.74-.59,1.6S584.54,405.08,584.37,405.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.49,395.61c0,.17-.9.05-1.9.26s-1.73.66-1.85.52.55-.89,1.72-1.13S576.56,395.45,576.49,395.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,391.41a3.47,3.47,0,0,1-1.83.26,8.37,8.37,0,0,1-2-.3A8.56,8.56,0,0,1,570,391a2,2,0,0,1-.61-.35.76.76,0,0,1-.22-.93,1,1,0,0,1,.72-.53,2.27,2.27,0,0,1,.69,0,5.67,5.67,0,0,1,1.2.22,6.63,6.63,0,0,1,1.85.85c1,.66,1.35,1.28,1.29,1.33s-.57-.43-1.52-.95a7.12,7.12,0,0,0-1.77-.67,5.39,5.39,0,0,0-1.1-.17c-.4,0-.73,0-.8.19s0,.09.07.2a1.85,1.85,0,0,0,.45.25,10.78,10.78,0,0,0,1.05.41,10.28,10.28,0,0,0,1.87.41A12.88,12.88,0,0,1,575,391.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.79,391.7c-.06,0-.51-.55-.75-1.69a6.18,6.18,0,0,1,0-2,6.82,6.82,0,0,1,.3-1.18,1.52,1.52,0,0,1,1-1.09.87.87,0,0,1,.84.39,2.61,2.61,0,0,1,.29.65,4.07,4.07,0,0,1,.18,1.23,4.25,4.25,0,0,1-.5,2c-.57,1-1.28,1.37-1.3,1.31s.49-.51.9-1.5a4.17,4.17,0,0,0,.32-1.8,3.53,3.53,0,0,0-.19-1.05c-.11-.38-.3-.67-.44-.61s-.45.36-.55.69a6.06,6.06,0,0,0-.31,1.06,6.75,6.75,0,0,0-.08,1.87C574.59,391,574.88,391.66,574.79,391.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "527.86 315.13 496.59 383.27 517.24 395.67 560.48 313.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.43,397.22,557,400.82l-13.43-80.14-66.35,4.81A16.16,16.16,0,0,1,472,325c-18.63-5.11-16.11-28.87-14.31-32.68l91.81-2.63a19.54,19.54,0,0,1,19.92,16.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.76,296.08l.33-33.88s-4.37-22-5.67-30.69c-2-13.44-4.76-19.83,17.26-29.38l4.82-1.86,7.45.1c8.88.67,18.24,8.7,18.46,14L508,290.74Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.14,210s-6.22,13.38-5,25.57l23.17,22.24c5.19,5.78,11.69,8.24,20,8.74l47.94,5.24,1.33-12.54L500,246.33c-1.82-.34-2.73-2.23-4.12-3.45L458.14,210",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.39,213.86a3.28,3.28,0,0,1,.92-.62,11.43,11.43,0,0,1,3.1-.87,16,16,0,0,1,5.18,0,5.37,5.37,0,0,1,1.52.52,15.29,15.29,0,0,1,1.41,1c.92.72,1.85,1.55,2.8,2.45,1.92,1.79,3.74,4.06,5.87,6.36s4.46,4.77,7,7.36,5.27,5.3,8.19,8.1c1.47,1.4,3,2.82,4.59,4.21.81.66,1.61,1.44,2.38,2.17A5.76,5.76,0,0,0,500,246.1h0L545.67,259l.21.06,0,.22c-.09.89-.2,1.84-.3,2.81-.35,3.33-.7,6.63-1,9.73l0,.26-.26,0L524,269.82l-9.6-1.05-9.19-.93c-3-.33-5.89-.67-8.7-1.08a39.17,39.17,0,0,1-8.06-1.87,29.68,29.68,0,0,1-6.78-3.65c-2-1.41-3.88-2.88-5.61-4.33-6.85-5.84-11.88-11.07-15.37-14.63-1.73-1.79-3.06-3.2-3.95-4.16l-1-1.1-.33-.39s.13.11.37.35.59.61,1,1.07l4,4.1c3.53,3.51,8.6,8.7,15.46,14.49,1.73,1.43,3.58,2.89,5.59,4.28a29.9,29.9,0,0,0,6.72,3.58,39.13,39.13,0,0,0,8,1.82c2.81.4,5.71.74,8.69,1.06l9.19.9,9.6,1.05,20.3,2.21-.29.23c.33-3.1.68-6.4,1-9.74.11-1,.21-1.92.3-2.81l.19.28-45.6-12.95h0a6.08,6.08,0,0,1-2.92-1.69c-.81-.77-1.54-1.49-2.37-2.18-1.61-1.4-3.12-2.83-4.59-4.23-2.92-2.81-5.64-5.54-8.17-8.14s-4.85-5.08-7-7.41-3.91-4.59-5.81-6.38a33.31,33.31,0,0,0-2.76-2.45,11.85,11.85,0,0,0-1.38-1,4.83,4.83,0,0,0-1.45-.51,15.51,15.51,0,0,0-5.11-.08,11.55,11.55,0,0,0-3.09.79A7,7,0,0,0,454.39,213.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.36,170.88l2.32,33a10.28,10.28,0,0,0,10.26,9.55h0a10.28,10.28,0,0,0,10.26-10.95c-.21-3.14-.39-5.71-.39-5.71s8-1.24,8.08-9.23c.06-4.61-.74-15.07-1.42-23.09A10.47,10.47,0,0,0,485,154.87h-4.83A14.76,14.76,0,0,0,466.36,170.88Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.82,196.64a18.61,18.61,0,0,1-10.41-2.95s2.46,5.74,10.43,5Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.68,174.7a1.14,1.14,0,0,1-1.1,1.15,1.08,1.08,0,0,1-1.18-1,1.15,1.15,0,0,1,1.1-1.16A1.1,1.1,0,0,1,493.68,174.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.1,172.45c-.15.15-1-.49-2.24-.49s-2.12.62-2.26.47.08-.34.48-.62a3.08,3.08,0,0,1,1.8-.56,3,3,0,0,1,1.78.58C494,172.11,494.16,172.38,494.1,172.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.16,174.7a1.13,1.13,0,0,1-1.1,1.15,1.08,1.08,0,0,1-1.18-1,1.15,1.15,0,0,1,1.1-1.16A1.1,1.1,0,0,1,482.16,174.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,172.68c-.14.15-1-.49-2.24-.49s-2.12.62-2.25.47.07-.34.47-.62a3.08,3.08,0,0,1,1.8-.56,3,3,0,0,1,1.78.57C482,172.34,482.11,172.61,482,172.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.49,181.78a8.18,8.18,0,0,1,2-.36c.31,0,.61-.1.66-.31a1.5,1.5,0,0,0-.21-.93L488,177.8a40.28,40.28,0,0,1-2.08-6.24,42.44,42.44,0,0,1,2.58,6.05l.88,2.4a1.81,1.81,0,0,1,.17,1.23.79.79,0,0,1-.52.46,2.21,2.21,0,0,1-.53.07A8,8,0,0,1,486.49,181.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.88,182.63c.2,0,.2,1.32,1.34,2.26s2.56.8,2.57,1-.32.25-.92.27a3.32,3.32,0,0,1-2.14-.75,2.88,2.88,0,0,1-1-1.9C482.64,183,482.79,182.62,482.88,182.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.35,167.87c-.12.33-1.34.18-2.78.35s-2.61.57-2.8.27.12-.46.59-.78a4.84,4.84,0,0,1,4.25-.47C482.14,167.45,482.41,167.71,482.35,167.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.64,168.9c-.21.28-1.06,0-2.07,0s-1.88.18-2.08-.11.05-.42.43-.68a2.83,2.83,0,0,1,1.69-.46,2.89,2.89,0,0,1,1.65.56C493.62,168.48,493.74,168.76,493.64,168.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.05,176.88c-.14-.06-5.49-1.63-5.31,3.83s5.61,4.16,5.62,4S469.05,176.88,469.05,176.88Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.62,182.7s-.09.07-.25.15a1,1,0,0,1-.71,0,2.35,2.35,0,0,1-1.15-2.07,3.16,3.16,0,0,1,.22-1.37,1.11,1.11,0,0,1,.69-.76.49.49,0,0,1,.57.25c.08.15.05.26.08.27s.11-.1.06-.32a.59.59,0,0,0-.23-.34.71.71,0,0,0-.53-.12,1.32,1.32,0,0,0-1,.88,3.17,3.17,0,0,0-.28,1.53,2.45,2.45,0,0,0,1.46,2.31,1,1,0,0,0,.86-.17C467.62,182.83,467.64,182.71,467.62,182.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,176.69a2.88,2.88,0,0,1,2.63,1.35c.35.78.43,1.66.78,2.44a2,2,0,0,0,2,1.29,1.68,1.68,0,0,0,1.14-1.25,4.53,4.53,0,0,0,0-1.76c-.32-2.55-.85-5.07-.95-7.64a13,13,0,0,1,1.61-7.42,7.14,7.14,0,0,1,6.38-3.59c1.7.14,3.25,1,4.94,1.26a6.68,6.68,0,0,0,5.54-1.85,11.11,11.11,0,0,1,1-.75,3.09,3.09,0,0,0-.57-1.68c-3.35-3.1-9.37-4-13.79-2.85a15.93,15.93,0,0,0-10.45,8.37c-1.9,4.14-1.34,9.89-.29,14.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.56,163.21s-20.94-6.74-30,11.38a33.78,33.78,0,0,1-1.36-7c0-1.62,1-11.29,10.92-14.33C475.12,153.3,490.11,147.58,495.56,163.21Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.56,163.66a4.56,4.56,0,0,0,7.26.66,2.68,2.68,0,0,0,5.07-.26,6.21,6.21,0,0,0,2,1.49,2.08,2.08,0,0,0,2.33-.49,2,2,0,0,0-.15-2.4,4.88,4.88,0,0,0-2.12-1.43,15.35,15.35,0,0,0-7.9-1.2,10.67,10.67,0,0,0-6.93,3.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.56,163.21a9.73,9.73,0,0,0-6.66-3c-6.18-.27-17.74,3.2-23.34,14.4a33.78,33.78,0,0,1-1.36-7c0-1.62,1-11.29,10.92-14.33C475.12,153.3,490.11,147.58,495.56,163.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M466.43,172.47a39.43,39.43,0,0,1,12.2-11.68c4.82-3,12.78-6,18.26-7.44a11.92,11.92,0,0,1,5.05-.53,4.55,4.55,0,0,1,3.74,3.06c.52,2.07-3.15,5.26-4.88,6.51a55.21,55.21,0,0,1-5.24,3.1s.05-3.84-6.09-4.63C481.12,159.79,466.43,172.47,466.43,172.47Z",
    style: {
      fill: "#015441"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M459.06,240.52c2.16,5.21,4.34,11.64,7.47,16.33s7.31,8.86,12.51,11c6.54,2.74,14.27,3.18,20.77.38.53-.23,1.57-.52,1.47-1.09,0,0-2.15-.25-2.82-.36C485.33,264.6,483.9,263,477.61,258c-3.92-3.09-12.61-12.46-18.55-17.48"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M500.82,278.46a5.49,5.49,0,0,1-.55,1.22,15.25,15.25,0,0,1-2.12,3A23,23,0,0,1,488,288.87a46.53,46.53,0,0,1-11.84,1.77c-1.53.06-2.77.07-3.62.07a7.73,7.73,0,0,1-1.33-.06,5.86,5.86,0,0,1,1.32-.15l3.61-.23a51.81,51.81,0,0,0,11.71-1.9,23.8,23.8,0,0,0,10.06-6A25.64,25.64,0,0,0,500.82,278.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.39,403.21a1,1,0,0,1-.08-.31c0-.23-.1-.54-.18-.92-.15-.84-.37-2-.64-3.54-.55-3.12-1.32-7.57-2.28-13.06-1.87-11.06-4.45-26.29-7.3-43.11-1.27-7.62-2.48-14.9-3.59-21.55l.26.21L514.87,323l-8.24.56-2.2.13-.56,0h-.2l.19,0,.57-.07,2.19-.2,8.23-.7,28.69-2.29.22,0,0,.22c1.12,6.65,2.35,13.93,3.63,21.54,2.79,16.83,5.31,32.07,7.15,43.14.88,5.5,1.6,10,2.11,13.08l.54,3.57c.06.38.1.69.13.92A1.29,1.29,0,0,1,557.39,403.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.3,313.54c.09.12-1.66,1.62-3.64,3.64s-3.46,3.79-3.58,3.69a23.82,23.82,0,0,1,7.22-7.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,203.17s.06.11.12.33a4.69,4.69,0,0,1,.19,1,8.21,8.21,0,0,1-.48,3.64,9.32,9.32,0,0,1-3.3,4.32,10,10,0,0,1-6.41,1.72,11.58,11.58,0,0,1-6.23-2.34,13.23,13.23,0,0,1-3.54-4.13,14.28,14.28,0,0,1-1.36-3.4c-.1-.42-.17-.75-.2-1s0-.35,0-.35a22.69,22.69,0,0,0,1.89,4.54,13.71,13.71,0,0,0,3.51,3.93,11.33,11.33,0,0,0,6,2.2,9.71,9.71,0,0,0,6.11-1.59,9.22,9.22,0,0,0,3.22-4.06,8.49,8.49,0,0,0,.63-3.49C489.08,203.65,489,203.19,489,203.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.11,246.84a4.19,4.19,0,0,1-.22-1c-.11-.79-.24-1.75-.4-2.86-.33-2.55-.76-5.83-1.23-9.46s-.81-7-1-9.48c-.11-1.21-.18-2.2-.22-2.88a3.93,3.93,0,0,1,0-1.06,4.93,4.93,0,0,1,.21,1c.11.79.24,1.74.39,2.86.32,2.55.73,5.83,1.18,9.46s.84,7,1.08,9.47c.11,1.22.19,2.2.24,2.89A4.54,4.54,0,0,1,503.11,246.84Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.8e37c64d8295dfcc9f28c8b9e40a7747.svg";
export { ForwardRef as ReactComponent };